export default "__VITE_ASSET__ExAjdZ4Y__"